"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SeatReservationContainerModule = _interopRequireDefault(require("./SeatReservationContainer.module.scss"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _styles = require("@material-ui/core/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Seat reservation container component
 *
 * Renders containers around groups of seats in seat plans.
 * 
 * @package HOPS
 * @subpackage SeatReservation
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class SeatReservationContainer extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    const def = this.props.def;
    const colour = def.Container.Colour;
    const styles = {
      background: colour ? (0, _colorManipulator.fade)(colour, !this.props.focused ? 0.25 : 0.5) : undefined,
      borderColor: colour ? (0, _colorManipulator.fade)(colour, 0.6) : this.props.theme.palette.text.secondary,
      gridColumn: `${def.X1 + 1} / ${def.X2 + 2}`,
      gridRow: `${def.Y1 + 1} / ${def.Y2 + 2}`
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _SeatReservationContainerModule.default.root,
      style: styles,
      title: def.Container.Label
    });
  }
  static propTypes = {
    def: _propTypes.default.object,
    focused: _propTypes.default.bool
  };
  static defaultProps = {
    focused: false
  };
}
var _default = (0, _styles.withTheme)(SeatReservationContainer);
exports.default = _default;